import React from 'react';

const LegalLayout = ({ title, children }) => {
  return (
    <section className="section">
      <div className="container" style={{ maxWidth: '900px' }}>
        <h1 className="heading-secondary mb-lg">{title}</h1>
        <div className="text-base legal-content" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
          {children}
        </div>
      </div>
    </section>
  );
};

export default LegalLayout;
